<template>
  <shared-product-provide v-if="account && Object.keys(account).length > 0" :product="product" :fromModule="fromModule" :toModule="toModule" :account="{ identifier: account.shopId }">
    <loader :loading="loadingAttributes || loadingSizeCharts || loading"/>

    <form-group :required="true" :label="$t('condition.label')" :columns="3" :error="getError('condition',  product.condition)">
      <select v-model="product.condition" class="form-select">
        <option v-for="condition in conditionOptions" :value="condition.value">{{ condition.label }}</option>
      </select>
    </form-group>

    <form-group label="Forma de envio" :columns="3" :required="true" :error="getError('shippingOptionSelected', product.shippingMethods)">
      <multiselect
        v-model="shippingOptionSelected"
        :options="shippingOptions"
        track-by="logistics_channel_id"
        label="logistics_channel_name"
        :multiple="true"
        :close-on-select="false"
        :clear-on-select="false"
        :hide-selected="true"
        placeholder="Selecione uma ou mais formas de envio"
      />
    </form-group>

    <form-group :required="true" label="Frete grátis" :columns="3">
      <select v-model="product.shippingFree" class="form-select">
        <option v-for="shippingFreeOption in shippingFreeOptions" :value="shippingFreeOption">{{ $t(`${shippingFreeOption}.label`) }}</option>
      </select>
    </form-group>

    <form-group label="Categoria de nivel 1" :columns="3" :error="getError('category', product.productId)" :required="true">
      <multiselect
        v-model="category"
        :options="categories"
        selectLabel=""
        selectedLabel=""
        label="name"
        track-by="name"
        placeholder="Escolha"
      />
    </form-group>

    <form-group label="Categoria de nivel 2" :columns="3" :error="getError('categoryFather', product.productId)" :required="isCategoryFatherRequired" v-if="category !== null && isCategoryFatherRequired === true">
      <multiselect
          v-model="categoryFather"
          :options="category.children"
          selectLabel=""
          selectedLabel=""
          placeholder="Escolha"
          label="name"
          track-by="name"
      />
    </form-group>

    <form-group label="Categoria de nivel 3" :columns="3" :error="getError('categoryChildren',  product.productId)" :required="isCategoryChildrenRequired" v-if="categoryFather !== null && categoryFather !== '' && category !== null && category !== '' && isCategoryChildrenRequired === true">
      <multiselect
          v-model="categoryChildren"
          :options="categoryFather.children"
          selectLabel=""
          selectedLabel=""
          placeholder="Escolha"
          label="name"
          track-by="name"
      />
    </form-group>

    <form-group label="Categoria de nivel 4" :columns="3" :error="getError('categoryFourth',  product.productId)" :required="isCategoryFourthRequired" v-if="categoryChildren !== null && categoryChildren !== '' && categoryFather !== null && categoryFather !== '' && category !== null && category !== '' && isCategoryFourthRequired === true">
      <multiselect
          v-model="categoryFourth"
          :options="categoryChildren.children"
          selectLabel=""
          selectedLabel=""
          placeholder="Escolha"
          label="name"
          track-by="name"
      />
    </form-group>

    <template v-if="sizeCharts.length">
      <div class="l-col-12@md">
        <div class="divider"><span>Tabela de medidas</span></div>
      </div>
      <form-group label="Tabela de medidas" :columns="3" :required="true" :error="getError('sizeChart', product.productId)">
        <select class="form-select" v-model="selectedSizeChart" :disabled="disabledInputs()">
          <option :value="null" selected>{{ $t('select.label') }}</option>
          <option v-for="sizeChart in sizeCharts" :key="sizeChart.id" :value="sizeChart">{{ sizeChart.name }}</option>
        </select>
      </form-group>
    </template>

    <div class="l-col-12@md" v-if="visibleAttributes.length">
      <div class="divider"><span>Atributos</span></div>
    </div>
    <form-group v-for="attribute in visibleAttributes" :key="attribute.attribute_id" :label="resolveName(attribute)" :columns="3" :error="getError(attribute.attribute_id,  product.productId)" :required="isAttributeRequired(attribute)">
      <template v-if="isSingleComboBox(attribute)">
        <input class="form-input" type="text" v-model="attribute.value" :list="attributeOptionsId(attribute)" :disabled="disabledInputs()">
        <datalist :id="attributeOptionsId(attribute)">
          <option v-for="attributeValue in attribute.attribute_value_list" :key="attributeValue.value_id" :value="resolveName(attributeValue)"/>
        </datalist>
      </template>

      <select class="form-select" :multiple="[4, 5].includes(attribute.attribute_info.input_type)" v-model="attribute.value" v-else-if="attribute.attribute_value_list && [1, 4, 5].includes(attribute.attribute_info.input_type)" @change="checkSelectionLimit(attribute, attribute.attribute_info.max_value_count !== undefined ? attribute.attribute_info.max_value_count : false)">
        <option v-if="attribute.attribute_info.input_type === 1" :value="undefined" selected>{{ $t('select.label') }}</option>
        <option v-for="attributeValue in attribute.attribute_value_list" :key="attributeValue.value_id" :value="attributeValue.value_id">{{ resolveName(attributeValue) }}</option>
      </select>

      <input class="form-input" type="text" v-model="attribute.value" :disabled="disabledInputs()" :error="getError(attribute.value,  product.productId)" v-else>
      <select class="form-select" v-model="attribute.value_unit" v-if="attribute.attribute_info.format_type == 2">
        <option :value="undefined" selected>{{ $t('select.label') }}</option>
        <option v-for="attributeValueUnit in attribute.attribute_info.attribute_unit_list" :key="attributeValueUnit" :value="attributeValueUnit">{{ attributeValueUnit }}</option>
      </select>
    </form-group>

    <div class="l-col-12@md" v-if="moduleConfigurations !== null && moduleConfigurations.taxInfo.useShopeeInvoice">
      <div class="divider"><span>Atributos Fiscais </span></div>
    </div>

      <form-group v-if="moduleConfigurations !== null && moduleConfigurations.taxInfo.useShopeeInvoice" label="NCM" :columns="3" :error="getError('ncm', product.ncm)" :required="true">
        <input v-model="product.ncm" class="form-input" :disabled="disabledInputs()"></input>
      </form-group>

      <form-group v-if="moduleConfigurations !== null && moduleConfigurations.taxInfo.useShopeeInvoice" label="CFOP - Código para o mesmo estado" :columns="3" :error="getError('cfopSameState', product.cfopSameState)" :required="true">
        <input v-model="product.cfopSameState" class="form-input" :disabled="disabledInputs()"></input>
      </form-group>

      <form-group v-if="moduleConfigurations !== null && moduleConfigurations.taxInfo.useShopeeInvoice" label="CFOP - Código para um estado diferente" :columns="3" :error="getError('cfopDifferentState', product.cfopDifferentState)" :required="true">
        <input v-model="product.cfopDifferentState" class="form-input" :disabled="disabledInputs()"></input>
      </form-group>

      <form-group v-if="moduleConfigurations !== null && moduleConfigurations.taxInfo.useShopeeInvoice" label="CSOSN" :columns="3" :error="getError('csosn', product.csosn)" :required="true">
        <input v-model="product.csosn" class="form-input" :disabled="disabledInputs()"></input>
      </form-group>

      <form-group v-if="moduleConfigurations !== null && moduleConfigurations.taxInfo.useShopeeInvoice" label="Origem" :columns="3" :error="getError('origin', product.origin)" :required="true">
        <select class="form-select" v-model="product.origin">
          <option value="domestic">Nacional</option>
          <option value="foreig">Importado</option>
        </select>
      </form-group>

      <form-group v-if="moduleConfigurations !== null && moduleConfigurations.taxInfo.useShopeeInvoice" label="CEST" :columns="3" :error="getError('cest', product.cest)" :required="true">
        <input v-model="product.cest" class="form-input" :disabled="disabledInputs()"></input>
      </form-group>

    <form-group v-if="moduleConfigurations !== null && moduleConfigurations.taxInfo.useShopeeInvoice" label="Unidade de Medida" :columns="3" :error="getError('measureUnit', product.measureUnit)" :required="true">
      <input v-model="product.measureUnit" class="form-input" :disabled="disabledInputs()"></input>
    </form-group>

  </shared-product-provide>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SharedProductProvide from '@/components/marketplace/shared/provide/Product'
import FormGroup from '@/components/template/FormGroup'
import api from '@/api'
import Multiselect from 'vue-multiselect'
import Loader from '@/components/template/Loader'
import notifier from '@/notifier'
import { findCharacteristicValue, getCharacteristicLabel, getProductCharacteristics } from '@/components/marketplace/shared/provide/presetCharacteristics'
import shopeeAnvisaCategories from '@/storage/shopeeAnvisaCategories'

export default {
  provide: {
    moduleDI: {
      type: 'marketplace',
      identifier: 'shopee'
    },
    maxTitleLengthDI: 256,
    maxDescriptionLengthDI: 5000,
    allowDescriptionHtml: false
  },
  data: () => ({
    loading: false,
    loadingAttributes: false,
    loadingSizeCharts: false,
    sizeCharts: [],
    selectedSizeChart: null,
    isCategoryFatherRequired: true,
    isCategoryChildrenRequired: true,
    isCategoryFourthRequired: true,
    havePresetCategory: false,
    categories: [],
    shippingOptions: [],
    attributes: [],
    category: null,
    categoryFather: null,
    categoryChildren: null,
    categoryFourth: null,
    categoryPreset: null,
    shippingOptionSelected: null,
    moduleConfigurations: null,
    conditionOptions: [{
      value: 'NEW',
      label: 'Novo'
    }, {
      value: 'USED',
      label: 'Usado'
    }],
    shippingFreeOptions: [
      false,
      true
    ]
  }),
  props: {
    product: {
      type: Object,
      required: true
    },
    fromModule: {
      type: Object,
      required: true
    },
    toModule: {
      type: Object,
      required: true
    },
    account: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('errors', [
      'getError'
    ]),
    visibleAttributes () {
      const visibleAttributes = []
      const appendAttributes = attributes => {
        attributes.forEach(attribute => {
          if (visibleAttributes.some(visibleAttribute => visibleAttribute.attribute_id === attribute.attribute_id)) {
            return
          }
          visibleAttributes.push(attribute)
          this.selectedOptions(attribute).forEach(option => appendAttributes(option.child_attribute_list || []))
        })
      }
      appendAttributes(this.attributes)
      return visibleAttributes
    }
  },
  async mounted () {
    this.loading = true
    this.product.category = ''
    this.categoryFather = ''
    this.categoryChildren = ''
    this.categoryFourth = ''
    this.product.condition = 'NEW'
    this.product.shippingFree = false

    if (!this.account || !this.account.shopId) {
      this.loading = false
      this.$parent.loadingProducts(false)
      return
    }

    await this.loadAccountData()
  },
  methods: {
    ...mapActions('errors', [
      'addError',
      'clearErrors'
    ]),
    async loadAccountData () {
      try {
        let categoriesShopee = await api.shopee.getCategories(this.account.shopId)
        this.categories = []
        for (let i in categoriesShopee) {
          this.categories.push(categoriesShopee[i])
        }
      } catch (e) {
        notifier.error('Não foi possível buscar as categorias do Shopee.')
        this.categories = []
      }

      try {
        this.moduleConfigurations = await api.getConfiguration('marketplace', 'shopee')
      } catch (e) {
        notifier.error('Não foi possível buscar as configurações do Shopee.')
      }

      const presetCategorization = this.$parent.getPresetItemsCategorization(this.product.categories)

      if (presetCategorization !== null && presetCategorization !== undefined) {
        const category = this.categories.find(category => category.id === presetCategorization['categories'][0].id)
        if (category !== undefined) {
          this.category = category
          if (category.children && presetCategorization['categories'][1] !== undefined) {
            const categoryFather = category.children.find(category => category.id === presetCategorization['categories'][1].id)
            this.categoryFather = categoryFather
            this.getAttributes(categoryFather.id)
            if (categoryFather.children && presetCategorization['categories'][2] !== undefined) {
              const categoryChildren = categoryFather.children.find(category => category.id === presetCategorization['categories'][2].id)
              this.havePresetCategory = true
              this.categoryChildren = categoryChildren
              this.getAttributes(categoryChildren.id)
              if (categoryChildren.children && presetCategorization['categories'][3] !== undefined) {
                const categoryFourth = categoryChildren.children.find(category => category.id === presetCategorization['categories'][3].id)
                this.havePresetCategory = true
                this.categoryFourth = categoryFourth
                this.getAttributes(categoryFourth.id)
              }
            }
          }
        }
      }

      try {
        this.shippingOptions = await api.shopee.getShippingMethods(this.account.shopId)
        if (this.shippingOptions.length) {
          this.shippingOptionSelected = [this.shippingOptions[0]]
        }
      } catch (e) {
        notifier.error('Não foi possível buscar as formas de envio do Shopee.')
        this.shippingOptions = []
      }

      this.loading = false
      this.$parent.loadingProducts(false)
    },
    formatProduct () {
      this.clearErrors()

      if (this.shippingOptionSelected === null || this.shippingOptionSelected === undefined || this.shippingOptionSelected === '') {
        this.addError({
          productId: this.product.productId,
          property: `shippingOptionSelected`,
          error: {
            message: 'required',
            value: 1
          }
        })
      }

      if (this.sizeCharts.length && !this.selectedSizeChart) {
        this.addError({
          productId: this.product.productId,
          property: `sizeChart`,
          error: {
            message: 'required',
            value: 1
          }
        })
      }

      if (this.product.brand === null || this.product.brand === undefined || this.product.brand === '') {
        this.addError({
          productId: this.product.productId,
          property: `brand`,
          error: {
            message: 'required',
            value: 1
          }
        })
      }
      if (this.moduleConfigurations && this.moduleConfigurations.taxInfo.useShopeeInvoice && (this.product.ncm === null || this.product.ncm === undefined || this.product.ncm === '')) {
        this.addError({
          productId: this.product.productId,
          property: `ncm`,
          error: {
            message: 'required',
            value: 1
          }
        })
      }
      if (this.moduleConfigurations && this.moduleConfigurations.taxInfo.useShopeeInvoice && (this.product.cfopSameState === null || this.product.cfopSameState === undefined || this.product.cfopSameState === '')) {
        this.addError({
          productId: this.product.productId,
          property: `cfopSameState`,
          error: {
            message: 'required',
            value: 1
          }
        })
      }
      if (this.moduleConfigurations && this.moduleConfigurations.taxInfo.useShopeeInvoice && (this.product.cfopDifferentState === null || this.product.cfopDifferentState === undefined || this.product.cfopDifferentState === '')) {
        this.addError({
          productId: this.product.productId,
          property: `cfopDifferentState`,
          error: {
            message: 'required',
            value: 1
          }
        })
      }
      if (this.moduleConfigurations && this.moduleConfigurations.taxInfo.useShopeeInvoice && (this.product.csosn === null || this.product.csosn === undefined || this.product.csosn === '')) {
        this.addError({
          productId: this.product.productId,
          property: `csosn`,
          error: {
            message: 'required',
            value: 1
          }
        })
      }
      if (this.moduleConfigurations && this.moduleConfigurations.taxInfo.useShopeeInvoice && (this.product.origin === null || this.product.origin === undefined || this.product.origin === '')) {
        this.addError({
          productId: this.product.productId,
          property: `origin`,
          error: {
            message: 'required',
            value: 1
          }
        })
      }
      if (this.moduleConfigurations && this.moduleConfigurations.taxInfo.useShopeeInvoice && (this.product.cest === null || this.product.cest === undefined || this.product.cest === '')) {
        this.addError({
          productId: this.product.productId,
          property: `cest`,
          error: {
            message: 'required',
            value: 1
          }
        })
      }
      if (this.moduleConfigurations && this.moduleConfigurations.taxInfo.useShopeeInvoice && (this.product.measureUnit === null || this.product.measureUnit === undefined || this.product.measureUnit === '')) {
        this.addError({
          productId: this.product.productId,
          property: `measureUnit`,
          error: {
            message: 'required',
            value: 1
          }
        })
      }
      if (this.category === null || this.category === undefined || this.category === '') {
        this.addError({
          productId: this.product.productId,
          sku: this.product.productId,
          property: 'category',
          error: {
            message: 'required',
            value: 1
          }
        })
      }
      if (this.categoryFather === null || this.categoryFather === undefined || this.categoryFather === '') {
        this.addError({
          productId: this.product.productId,
          sku: this.product.productId,
          property: 'categoryFather',
          error: {
            message: 'required',
            value: 1
          }
        })
      }

      this.visibleAttributes
        .map(attribute => {
          if ((attribute.value === null || attribute.value === undefined || attribute.value === '' || attribute.value.length === 0) && this.isAttributeRequired(attribute)) {
            this.addError({
              productId: this.product.productId,
              property: attribute.attribute_id,
              error: {
                message: 'required',
                value: 1
              }
            })
          }
          if (attribute.attribute_id === 101083 && attribute.value < 89) {
            notifier.warning(`${attribute.display_attribute_name} deve ser no mínimo 90 dias.`)
            this.addError({
              productId: this.product.productId,
              property: attribute.value,
              error: {
                message: 'required',
                value: 1
              }
            })
          }
        })
      const attributes = this.visibleAttributes
        .filter(attribute => {
          return attribute.value !== undefined && attribute.value !== ''
        })
        .map(attribute => {
          let attributeValueLabel = {}
          const selectedOptions = this.selectedOptions(attribute)
          const isCustomValue = attribute.attribute_value_list === undefined || (this.isSingleComboBox(attribute) && selectedOptions.length === 0)

          selectedOptions.forEach(option => {
            attributeValueLabel[option.value_id] = this.resolveName(option)
          })

          const validationType = [2, 3, 5].includes(attribute.attribute_info.input_type)
          const validationDate = validationType ? (attribute.attribute_info.input_validation_type === 4) : false

          return {
            id: attribute.attribute_id,
            label: this.resolveName(attribute),
            valueId: isCustomValue ? '' : attributeValueLabel,
            valueLabel: isCustomValue ? attribute.value : '',
            valueDataType: validationType ? attribute.attribute_info.input_validation_type : null,
            valueDateFormat: validationDate ? attribute.attribute_info.date_format_type : null,
            valueUnit: attribute.value_unit !== undefined ? attribute.value_unit : null
          }
        })
      this.product.variations.map(variation => {
        if (variation.attributes.hasOwnProperty('color') && (variation.attributes['color'] === null || variation.attributes['color'] === undefined || variation.attributes['color'] === '') && variation.selected) {
          this.addError({
            productId: this.product.productId,
            property: `attributes.color`,
            sku: variation.sku,
            error: {
              message: 'required',
              value: 1
            }
          })
        }
        if (variation.attributes.hasOwnProperty('size') && (variation.attributes['size'] === null || variation.attributes['size'] === undefined || variation.attributes['size'] === '') && variation.selected) {
          this.addError({
            productId: this.product.productId,
            property: `attributes.size`,
            sku: variation.sku,
            error: {
              message: 'required',
              value: 1
            }
          })
        }
        if (variation.attributes.hasOwnProperty('flavor') && (variation.attributes['flavor'] === null || variation.attributes['flavor'] === undefined || variation.attributes['flavor'] === '') && variation.selected) {
          this.addError({
            productId: this.product.productId,
            property: `attributes.flavor`,
            sku: variation.sku,
            error: {
              message: 'required',
              value: 1
            }
          })
        }
        if (variation.attributes.hasOwnProperty('voltage') && (variation.attributes['voltage'] === null || variation.attributes['voltage'] === undefined || variation.attributes['voltage'] === '') && variation.selected) {
          this.addError({
            productId: this.product.productId,
            property: `attributes.voltage`,
            sku: variation.sku,
            error: {
              message: 'required',
              value: 1
            }
          })
        }
      })
      return this.product.variations
        .filter(variation => variation.selected)
        .map(variation => ({
          productId: this.product.productId,
          condition: this.product.condition,
          productAttributes: this.withSizeChart(attributes),
          description: this.product.description,
          brand: this.product.brand,
          category: this.product.category,
          color: variation.attributes['color'] !== undefined && variation.attributes['color'] !== null ? variation.attributes['color'] : null,
          size: variation.attributes['size'] !== undefined && variation.attributes['size'] !== null ? variation.attributes['size'] : null,
          voltage: variation.attributes['voltage'] !== undefined && variation.attributes['voltage'] !== null ? variation.attributes['voltage'] : null,
          flavor: variation.attributes['flavor'] !== undefined && variation.attributes['flavor'] !== null ? variation.attributes['flavor'] : null,
          shippingFree: this.product.shippingFree,
          shippingMethods: this.shippingOptionSelected.map(item => item.logistics_channel_id),
          ean: variation.ean,
          height: variation.height,
          images: variation.images.length ? variation.images.map(image => ({
            url: image
          })) : null,
          length: variation.length,
          original: {
            product: this.product,
            variation: variation
          },
          price: variation.price,
          sku: variation.sku,
          source: this.fromModule,
          stock: variation.stock,
          title: this.product.title,
          weight: variation.weight,
          width: variation.width,
          account: {
            identifier: this.account.shopId
          },
          ncm: this.product.ncm,
          cfopSameState: this.product.cfopSameState,
          cfopDifferentState: this.product.cfopDifferentState,
          csosn: this.product.csosn,
          origin: this.product.origin,
          cest: this.product.cest,
          measureUnit: this.product.measureUnit
        })
      )
    },
    disabledInputs () {
      return this.product.status === 'sent' || this.product.status === 'error'
    },
    withSizeChart (attributes) {
      if (!this.selectedSizeChart) {
        return attributes
      }

      // Item reservado: o backend envia como size_chart_info, nao como atributo da Shopee.
      return attributes.concat({
        id: '__size_chart__',
        label: 'size_chart',
        valueId: { [this.selectedSizeChart.id]: this.selectedSizeChart.name },
        valueLabel: '',
        valueDataType: null,
        valueDateFormat: null,
        valueUnit: null
      })
    },
    async getSizeCharts (code) {
      this.loadingSizeCharts = true
      this.sizeCharts = []
      this.selectedSizeChart = null

      await api.shopee.getSizeCharts(this.account.shopId, code)
      .then(sizeCharts => {
        this.sizeCharts = sizeCharts
      })
      .catch(() => {
        notifier.error('Erro ao carregar as tabelas de medidas da categoria.', 'Erro')
      })
      .finally(() => {
        this.loadingSizeCharts = false
      })
    },
    async getAttributes (code) {
      this.loadingAttributes = true
      this.getSizeCharts(code)

      await api.shopee.getAttributes(this.account.shopId, code)
      .then(allAttributes => {
        this.attributes = allAttributes.map(attribute => this.presetAttribute(attribute))
      })
      .catch(() => {
        this.attributes = []
        notifier.error('Erro ao carregar os atributos da categoria.', 'Erro')
      })
      .finally(() => {
        this.product.category = code
        this.loadingAttributes = false
      })
    },
    presetAttribute (attribute) {
      if (attribute.value !== undefined) {
        return attribute
      }

      const characteristics = getProductCharacteristics(this.product)
      const name = this.resolveName(attribute)
      const options = attribute.attribute_value_list || []
      const inputType = attribute.attribute_info && attribute.attribute_info.input_type

      if (options.length && [1, 2, 4, 5].includes(inputType)) {
        const matched = findCharacteristicValue(name, options.map(option => this.resolveName(option)), characteristics)
        const option = matched !== undefined ? options.find(option => this.resolveName(option) === matched) : undefined

        if (option === undefined) {
          return attribute
        }

        if (inputType === 1) {
          attribute.value = option.value_id
        } else if (inputType === 2) {
          attribute.value = matched
        } else {
          attribute.value = [option.value_id]
        }

        return attribute
      }

      const label = getCharacteristicLabel(name, characteristics)

      if (label !== undefined) {
        attribute.value = label
      }

      return attribute
    },
    checkSelectionLimit (attribute, maxSelection) {
      if (maxSelection !== false && attribute.value.length > maxSelection) {
        attribute.value = attribute.value.slice(0, maxSelection)
      }
    },
    isSingleComboBox (attribute) {
      return attribute.attribute_info.input_type === 2
    },
    isAttributeRequired (attribute) {
      return attribute.mandatory || (this.isAnvisaAttribute(attribute) && shopeeAnvisaCategories.includes(Number(this.product.category)))
    },
    isAnvisaAttribute (attribute) {
      return /anvisa/i.test(`${this.resolveName(attribute) || ''} ${attribute.name || ''}`)
    },
    attributeOptionsId (attribute) {
      return `shopee-attribute-${this._uid}-${attribute.attribute_id}`
    },
    selectedOptions (attribute) {
      if (!attribute.attribute_value_list || attribute.value === undefined || attribute.value === null || attribute.value === '') {
        return []
      }

      if (this.isSingleComboBox(attribute)) {
        const normalize = value => String(value || '').trim().toLowerCase()
        const matchedOption = attribute.attribute_value_list.find(option => normalize(this.resolveName(option)) === normalize(attribute.value))
        return matchedOption ? [matchedOption] : []
      }

      const values = Array.isArray(attribute.value) ? attribute.value : [attribute.value]
      return attribute.attribute_value_list.filter(option => values.includes(option.value_id))
    },
    resolveName (attributeForm) {
      return attributeForm.multi_lang !== undefined && attributeForm.multi_lang[0].value !== undefined ? attributeForm.multi_lang[0].value : attributeForm.name
    }
  },
  watch: {
    async account (value) {
      if (value && value.shopId) {
        this.category = null
        this.categoryFather = null
        this.categoryChildren = null
        this.categoryFourth = null
        this.attributes = []

        try {
          let categoriesShopee = await api.shopee.getCategories(value.shopId)
          this.categories = []
          for (let i in categoriesShopee) {
            this.categories.push(categoriesShopee[i])
          }
        } catch (e) {
          notifier.error('Não foi possível buscar as categorias do Shopee.')
          this.categories = []
        }

        try {
          this.shippingOptions = await api.shopee.getShippingMethods(value.shopId)
          if (this.shippingOptions.length) {
            this.shippingOptionSelected = [this.shippingOptions[0]]
          }
        } catch (e) {
          notifier.error('Não foi possível buscar as formas de envio do Shopee.')
          this.shippingOptions = []
        }
      }
    },
    category (value) {
      if (!this.havePresetCategory) {
        if (value !== null && value !== '') {
          if (value.children.length === 0) {
            this.isCategoryFatherRequired = false
            this.category = ''
            this.categoryChildren = ''
            return
          }
          this.isCategoryFatherRequired = true
          this.categoryFather = ''
          this.categoryChildren = ''
        }
      }
    },
    categoryFather (value) {
      if (!this.havePresetCategory) {
        if (value !== null && value !== '') {
          if (!value.children) {
            this.isCategoryChildrenRequired = false
            this.categoryChildren = ''
            this.getAttributes(value.id)
            return
          }
          this.isCategoryChildrenRequired = true
          this.categoryChildren = ''
        }
      }
      this.havePresetCategory = false
    },
    categoryChildren (value) {
      if (!this.havePresetCategory) {
        if (value !== null && value !== '' && value.children === undefined) {
          this.isCategoryFourthRequired = false
          this.getAttributes(value.id)
          return
        }
        this.isCategoryFourthRequired = true
      }
      this.havePresetCategory = false
    },
    categoryFourth (value) {
      if (!this.havePresetCategory) {
        if (value !== null && value !== '') {
          this.getAttributes(value.id)
        }
      }
      this.havePresetCategory = false
    }
  },
  components: {
    SharedProductProvide,
    FormGroup,
    Multiselect,
    Loader
  }
}
</script>



// WEBPACK FOOTER //
// Product.vue?699ec47b